import React from 'react';
import { Package, Plane, Box, Ship, MapPin, Truck } from 'lucide-react';
import './AuthLayout.css';

const MODES = [
  'Unified Intelligent Dashboard',
  'Complete Logistics Solutions',
  'Fast Customs Clearance',
  'International Cargo Handling',
];

const AuthLayout = ({ children }) => (
  <div className="auth-page">
    {/* Decorative layer. Every dot / bubble / dot-grid below is placed at the
        same spot it sits in the approved reference design (coordinates are
        percentages of the reference's 1555x1011 canvas), so the composition
        holds at any desktop width. */}
    <div className="auth-decor" aria-hidden="true">
      <span className="auth-dot auth-dot-teal auth-dot-1" />
      <span className="auth-dot auth-dot-sky auth-dot-2" />
      <span className="auth-dot auth-dot-blue auth-dot-3" />
      <span className="auth-dot auth-dot-amber auth-dot-4" />
      <span className="auth-dot auth-dot-sky auth-dot-5" />
      <span className="auth-dot auth-dot-sky auth-dot-6" />

      <span className="auth-grid auth-grid-1" />
      <span className="auth-grid auth-grid-2" />
      <span className="auth-grid auth-grid-3" />

      <span className="auth-ring" />

      <svg className="auth-connector" viewBox="0 0 100 40" fill="none" preserveAspectRatio="none">
        <path d="M2,8 Q52,0 98,32" stroke="#93c5fd" strokeWidth="1.4" strokeDasharray="4 5" />
      </svg>

      <span className="auth-bubble auth-bubble-box">
        <Package size={22} />
      </span>
      <span className="auth-bubble auth-bubble-plane">
        <Plane size={26} />
      </span>
      <span className="auth-bubble auth-bubble-cube">
        <Box size={26} />
      </span>
      <span className="auth-bubble auth-bubble-mini">
        <span className="auth-bubble-mini-dot" />
      </span>
    </div>

    <main className="auth-main">
      <section className="auth-hero" aria-hidden="true">
        <div className="auth-pill">
          <span className="auth-pill-dot" />
          LIVE TRACKING
        </div>

        <h1 className="auth-headline">
          One Clear View,
          <br />
          For All Your <span className="auth-headline-accent">Shipments.</span>
        </h1>
        <p className="auth-subtext">
          Your Unified Intelligent Dashboard for tracking, bookings, logistics
          activity and all insights.
        </p>
      </section>

      <section className="auth-card-slot">{children}</section>
    </main>

    {/* Hero illustration. On desktop it is pinned to the page's bottom-left
        so it bleeds off the edges like the reference; below the desktop
        breakpoint it sits in normal flow under the card. */}
    <div className="auth-illustration" aria-hidden="true">
      <img src="/images/login-bg.png" alt="" className="auth-illustration-img" />

      <div className="auth-badge auth-badge-ship">
        <span className="auth-badge-icon auth-badge-icon-soft">
          <Ship size={15} />
        </span>
        <div>
          <div className="auth-badge-title">
            <span className="auth-badge-dot auth-badge-dot-green" />
            In Transit
          </div>
          <div className="auth-badge-sub">New York</div>
        </div>
      </div>

      <div className="auth-badge auth-badge-ontime">
        <span className="auth-badge-icon auth-badge-icon-solid">
          <MapPin size={15} />
        </span>
        <div>
          <div className="auth-badge-title">On Time</div>
          <div className="auth-badge-sub">London</div>
        </div>
      </div>

      <div className="auth-badge auth-badge-truck">
        <span className="auth-badge-icon auth-badge-icon-dark">
          <Truck size={15} />
        </span>
        <div>
          <div className="auth-badge-title">
            <span className="auth-badge-dot auth-badge-dot-orange" />
            Out for Delivery
          </div>
          <div className="auth-badge-sub">New Delhi</div>
        </div>
      </div>
    </div>

    {/* Bottom strip. It carries the four service points across the page —
        the artwork runs behind it, so the band is opaque enough to keep them
        readable. Each dot travels with its own phrase, so a wrapped row never
        ends on a dangling separator. */}
    <footer className="auth-footer">
      <div className="auth-footer-inner">
        <div className="auth-modes">
          {MODES.map((m) => (
            <span className="auth-mode" key={m}>
              <span className="auth-modes-sep">•</span>
              {m}
            </span>
          ))}
        </div>
        <span className="auth-footer-item auth-footer-item-right">
          Connecting Businesses Worldwide
          <span className="auth-footer-line" />
        </span>
      </div>
    </footer>
  </div>
);

export default AuthLayout;
